import React, { Component, Fragment, useState, useEffect } from 'react';


import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { uploadFileS3Bucket } from '../../../utilities/uploadFileS3Bucket';

import useUserStore from '../../../zustand/useUserStore.js';
import { MentionsInput ,Mention} from 'react-mentions';
import { Input } from '@shadcn/components/ui/input';
import { Col } from '@shadcn/components/ui/col';
import { Button } from '@shadcn/components/ui/button';

const AddComment = React.memo(({ orderName, refresh, addComment }) => {
  const history = useHistory();
  const initialState = {
    clientId: '',
    userName: '',
    user: '',
    orderName: '',
    title: '',
    description: '',
    comment_file: null,
    isFileUploaded: false,
    commentType: 'General',
    mentions: [],
    url: `${window.location.href}`,
    plainText: '',
  };

  const userList = useUserStore((state) => state.userList);
  const [state, setState] = useState(initialState);

  useEffect(() => {
    let userData = localStorage.getItem('authUser');
    if (userData) {
      userData = JSON.parse(userData);
      let userName = userData.userName;
      let user = userData._id;
      setState((prevState) => {
        return {
          ...prevState,
          userName: userName,
          user: user,
          orderName: orderName ? orderName : '',
          commentType: orderName ? 'Order' : 'General',
        };
      });
    }
  }, [orderName]);

  const handleInputChange = (
    name,
    newValue,
    mentions,
    plainText
  ) => {
    
    const ids = mentions.map(({ id }) => id);
    const mentionsUser = userList.filter((user) => ids.includes(user._id));
    
    setState((prevState) => {
      return {
        ...prevState,
        [name]: newValue,
        mentions: mentionsUser,
        plainText: plainText
      };
    });
  };

  const handleFileChange = ({ target: { files } }) => {
    const cancel = !files.length;
    if (cancel) return;
    setState((prevState) => {
      return {
        ...prevState,
        comment_file: files[0],
        isFileUploaded: true,
      };
    });
  };

  const handleCreateComment = async (e) => {
    e.preventDefault();
    const {
      commentType,
      orderName,
      userName,
      title,
      description,
      comment_file,
      isFileUploaded,
      user,
      mentions,
      plainText,
      url
    } = state;

    let commentFields = {
      orderName: orderName,
      userName: userName,
      files: null,
      title: title,
      description: description,
      comment_type: commentType,
      user: user,
      mentions: mentions,
      plainText: plainText,
      url: url
    };

    let [commentFile] = await Promise.all([
      isFileUploaded
        ? uploadFileS3Bucket(comment_file, `comment_file_${Date.now()}`)
        : comment_file,
    ]);

    commentFields = {
      ...commentFields,
      files: commentFile ? [commentFile] : [],
    };
    addComment(commentFields);
  };

  toast.configure({ autoClose: 8000, hideProgressBar: true });
  const { title, description, comment_file } = state;

  return (
    <form className="outer-repeater">
      <div data-repeater-list="outer-group" className="outer">
        <div data-repeater-item className="outer">
          <div className="flex flex-row mb-4 flex-wrap">
            <Col lg="12" className="d-flex align-items-center custome-input">
              <MentionsInput
                value={description}
                onChange={(e, newValue, plainText, mentions) =>
                  handleInputChange(
                    'description',
                    newValue,
                    mentions,
                    plainText
                  )
                }
                style={{
                  width: '100%',
                  control: {
                    backgroundColor: '#fff',
                    fontSize: 13,
                  },

                  '&multiLine': {
                    control: {
                      fontFamily: 'monospace',
                      minHeight: 60,
                    },
                    highlighter: {
                      padding: 9,
                      border: '1px solid transparent',
                    },
                    input: {
                      padding: 9,
                      border: '1px solid black',
                    },
                  },

                  '&singleLine': {
                    display: 'inline-block',
                    width: 180,

                    highlighter: {
                      padding: 1,
                      border: '2px inset transparent',
                    },
                    input: {
                      padding: 1,
                      border: '2px inset',
                    },
                  },

                  suggestions: {
                    zIndex: 100,
                    list: {
                      backgroundColor: 'white',
                      border: '1px solid rgba(0,0,0,0.15)',
                      fontSize: 12,
                    },
                    item: {
                      padding: '5px 15px',
                      borderBottom: '1px solid rgba(0,0,0,0.15)',
                      '&focused': {
                        backgroundColor: '#cee4e5',
                      },
                    },
                  },
                }}
                placeholder="Enter Comment..."
              >
                <Mention
                  trigger="@"
                  data={
                    userList?.map((item) => {
                      return { id: item._id, display: item.userName };
                    }) ?? []
                  }
                  style={{ backgroundColor: '#daf4fa' }}
                />
              </MentionsInput>
            </Col>
            <Col
              lg="12"
              className="d-flex mt-2"
              style={{ marginLeft: -8, display: 'flex' }}
            >
              <Input
                accept="*"
                className=" ml-2"
                type="file"
                id="comment_file"
                name="comment_file"
                label={comment_file || 'Add image or file'}
                onChange={(e) => handleFileChange(e)}
              />

              <Button
                style={{ width: '15%', marginRight: -8, minWidth: 60 }}
                className="ml-2"
                onClick={(e) => handleCreateComment(e)}
                type="submit"
                variant="primary"
              >
                Post
              </Button>
            </Col>
          </div>
        </div>
      </div>
    </form>
  );
});

export default AddComment;
